import { createContext } from "react";

const timeTableContext = createContext();

export default timeTableContext;